import { useMemo } from "react";
import { useAuth } from "@/shared/session";
import { useGetApplicants } from "@/core/applicants/useCases/useGetApplicants";
import { useGetCostCenters } from "@/core/costCenter/useCases/getCostCenters";
import { useGetWorkOrder } from "@/core/workOrders/useCases/useGetWorkOrder";
import type { FilterField } from "@/ui/filters/filterValues";

export const useVoucherFilterFields = (): FilterField[] => {
  const { session } = useAuth();
  const zone = session?.zone ?? "";

  const { data: applicants } = useGetApplicants({ zoneIds: zone });
  const { data: costCenters } = useGetCostCenters(zone);
  const { data: workOrders } = useGetWorkOrder({ zoneIds: zone || undefined });

  return useMemo(
    () => [
      { type: "dateRange", key: "date", label: "Fecha del vale" },
      {
        type: "select",
        key: "applicant",
        label: "Solicitante",
        options: applicants?.map((a) => ({ value: a.id, label: a.name })),
      },
      {
        type: "select",
        key: "costCenter",
        label: "Centro de costo",
        tagLabel: "C. costo",
        options: costCenters?.map((cc) => ({ value: cc.id, label: cc.name })),
      },
      {
        type: "select",
        key: "workOrder",
        label: "Orden de trabajo",
        tagLabel: "OT",
        placeholder: "Todas",
        options: workOrders?.map((wo) => ({
          value: wo.id,
          label: `${wo.code}-${wo.name}`,
        })),
      },
    ],
    [applicants, costCenters, workOrders],
  );
};
